import { FC } from 'react';
import { View } from 'react-big-calendar';
import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import { InterviewSchedulerView } from 'constants/enums';

import styles from './ViewSwitcher.module.scss';

interface ViewSwitcherProps {
  view: View;
  onView: (view: View) => void;
}

const ViewSwitcher: FC<ViewSwitcherProps> = ({ view, onView }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.viewSwitcherContainer}>
      <span
        className={cs(styles.viewSwitcherItem, {
          [styles.isActive]: view === InterviewSchedulerView.Week
        })}
        onClick={() => onView(InterviewSchedulerView.Week)}
      >
        {t('calendar.week')}
      </span>
      <span
        className={cs(styles.viewSwitcherItem, {
          [styles.isActive]: view === InterviewSchedulerView.Month
        })}
        onClick={() => onView(InterviewSchedulerView.Month)}
      >
        {t('calendar.month')}
      </span>
    </div>
  );
};

export default ViewSwitcher;
